import TableOfContents from './TableOfContents';

export default TableOfContents;
